import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const root = css`
  border-radius: ${spacing(12.5)}; // 100px
  padding: ${spacing(0.25, 0.5)}; // 2px 4px
`
export const active = css`
  background: linear-gradient(108deg, #21211f 38.67%, rgba(33, 32, 31, 0.2) 59.9%, #21211f 81.77%);
`
export const disabled = css`
  background-color: ${cssTheme.default.day.backgroundInvert};
  opacity: 0.5;
`
